'use strict';

export default class ModelFac {
  static get UID() {
    return 'modelFac';
  }

  constructor($http, siteConst, BASE_URLS) {
    'ngInject';
    Object.assign(this, { $http, siteConst, BASE_URLS } );
  }

  getModels() {
    var url = `${this.BASE_URLS.API}/api/site/${this.siteConst.id}/models/`;

    return this.$http.get(url);
  };

  getModel(modelId) {
    var url = `${this.BASE_URLS.API}/api/model/${modelId}`;

    return this.$http.get(url);
  };

  static factory($http, siteConst, BASE_URLS) {
    return new ModelFac($http, siteConst, BASE_URLS);
  }
}

ModelFac.factory.$inject = ModelFac.$inject;



// WEBPACK FOOTER //
// ./~/site_core/src/factories/modelFac.js